import axios from "axios"

const Api = axios.create({ baseURL: API_URL }) //API_URL defined in webpack.dev.js || webpack.prod.js

export default Api